import React from 'react';

interface IHashTagIconProps {
    size?: number;
    color?: string;
}

export const HashTagIcon: React.FC<IHashTagIconProps> = ({ size = 24, color = "black" }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.5039 84.416H27.8239L41.9359 15.584H49.6159L35.5039 84.416ZM57.5839 84.416H49.9039L64.0159 15.584H71.6959L57.5839 84.416ZM21.2959 64.544V57.824H76.1119V64.544H21.2959ZM23.8879 40.352V33.632H78.7039V40.352H23.8879Z" fill={color}/>
        </svg>
    );
};
